module.exports = __webpack_public_path__ + "static/media/Nuestra-Creencia.1076f4dc.jpeg";